import { render, staticRenderFns } from "./ApplicationGeneratorHandler.vue?vue&type=template&id=ec090132&scoped=true&"
import script from "./ApplicationGeneratorHandler.vue?vue&type=script&lang=js&"
export * from "./ApplicationGeneratorHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec090132",
  null
  
)

export default component.exports